import {buttonVariants} from "../ui/button.tsx";
import {ArrowRightIcon} from "@radix-ui/react-icons";
import {useTranslation} from "react-i18next";
import heroImg from '../../assets/landing-hero.jpg';

export const Hero = () => {
    const {t} = useTranslation();

    return (
        <section
            className={`min-h-screen -mt-[64px] bg-cover bg-center bg-no-repeat px-6 grid lg:grid-cols-2 place-items-center py-20 md:py-32 gap-10 dark:bg-charcoal`}
            style={{backgroundImage: `url(${heroImg})`}}
        >
            <div
                className="p-6 bg-opacity-50 bg-white dark:bg-opacity-50 dark:bg-black text-center lg:text-start space-y-6 rounded-lg">
                <main className="font-bold font-heading">
                    {t("landing.welcome")}
                    <h1 className="text-5xl md:text-6xl font-heading uppercase">
                        <span className="inline dark:bg-springGreen bg-springGreen text-transparent bg-clip-text">
                            {t("common.appTitle")}
                        </span>
                    </h1>
                    {t("landing.presentedBy")}
                </main>

                <p className="md:w-10/12 mx-auto lg:mx-0">
                    {t("landing.heroDesc")}
                </p>

                <div className="space-y-4 md:space-y-0 md:space-x-4">
                    <a
                        href="/auth/ibmid"
                        className={`w-full md:w-1/3 ${buttonVariants({
                            variant: "default",
                        })}`}
                    >
                        {t("landing.getStarted")}
                    </a>

                    <a
                        href="#about"
                        className={`w-full md:w-1/3 ${buttonVariants({
                            variant: "outline",
                        })}`}
                    >
                        {t("landing.learnMore")}
                        <ArrowRightIcon className="ml-2 w-5 h-5"/>
                    </a>
                </div>
            </div>
        </section>
    );
};
